export const MenusFocalPoint = {
  'company': {
    'context': [
      'points',
      'cash'
    ],
    'items': [
      {
        'items': [],
        'path': '/credit-approval',
        'label': 'Aprovação de Crédito',
        'enabled': true
      },
      {
        'items': [],
        'path': '/branch',
        'label': 'Cadastro de Filiais',
        'enabled': true
      },
      {
        'items': [],
        'path': '/branch-distribution-point',
        'label': 'Distribuição de Pontos Filiais',
        'enabled': true
      }
    ],
    'label': 'Focal Point',
    'enabled': true,
    'type': 'services'
  },
  'focalPoint': {
    'context': [
      'points',
      'cash'
    ],
    'items': [
      {
        'items': [],
        'path': '/branch-details',
        'label': 'Distribuição de Pontos Participantes',
        'enabled': true
      }
    ],
    'label': 'Focal Point',
    'enabled': true,
    'type': 'services'
  }
}



// WEBPACK FOOTER //
// ./src/App/MainMenu/CategoryMenu/MenusFocalPoint.js